import React from 'react';
import styled from 'styled-components';
import { whatsapp } from '@config';

const StyledWhatsappButton = styled.a`
  position: fixed;
  left: 25px;
  bottom: 25px;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  padding: 0;
  color: #ffffff;
  background-color: #25d366;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

  &:hover,
  &:focus-visible {
    color: #ffffff;
    background-color: #1ebe57;
    outline: none;
    transform: translateY(-3px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);
  }

  svg {
    width: 30px;
    height: 30px;
  }

  /* Móvil: esquina inferior izquierda respetando la barra del navegador
     (safe-area-inset-bottom para iOS Safari). */
  @media (max-width: 768px) {
    left: 16px;
    bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    width: 52px;
    height: 52px;

    svg {
      width: 27px;
      height: 27px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    transition: background-color 0.2s ease;
    &:hover,
    &:focus-visible {
      transform: none;
    }
  }
`;

const WhatsappFloat = () => {
  if (!whatsapp || !whatsapp.number) {
    return null;
  }

  const href = `https://wa.me/${whatsapp.number}${
    whatsapp.message ? `?text=${encodeURIComponent(whatsapp.message)}` : ''
  }`;

  return (
    <StyledWhatsappButton
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escríbeme por WhatsApp"
      title="Escríbeme por WhatsApp">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.24 8.24 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.19 8.19 0 0 1 2.41 5.83c0 4.55-3.7 8.24-8.24 8.24zm4.52-6.17c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43-.14-.01-.31-.01-.48-.01-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z" />
      </svg>
    </StyledWhatsappButton>
  );
};

export default WhatsappFloat;
